import { put, select, takeLatest } from 'redux-saga/effects'

import { Period } from '../../@paco/entities/Period/Period'
import { doesDateOverlapWithPeriod } from '../../@paco/entities/Period/PeriodHelpers'
import { differenceInDays } from '../../@paco/helpers/date'

import { getLoketLeaveBalance } from '../../helpers/api-ts/loketLeaveBalance'
import { PayrollPeriod } from '../../models'
import {
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE,
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_REQUEST,
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_FAILURE,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS,
    ABSENCES_SAGA_GET_CURRENT_PAYROLL_PERIOD,
    ABSENCES_SAGA_GET_EMPLOYEE_LOKET_BALANCES,
} from '../actionTypes'
import { GetEmployeeLoketBalances } from './absencesModel'

export function* getCurrentPayrollPeriod(): any {
    yield put({ type: ABSENCES_GET_CURRENT_PAYROLL_PERIOD_REQUEST })

    try {
        const state = yield select()
        const { payrollPeriods } = state.appReducer

        const currentDate = new Date()
        const matchingPayrollPeriod = payrollPeriods
            .find((payrollPeriod: PayrollPeriod) => doesDateOverlapWithPeriod(currentDate, { start: payrollPeriod.start, end: payrollPeriod.end.date } as Period))

        const sortedPayrollPeriods = [...payrollPeriods].sort(
            (payrollPeriodA: PayrollPeriod, payrollPeriodB: PayrollPeriod) => {
                if (Math.abs(differenceInDays(payrollPeriodB.start, currentDate))
                    < Math.abs(differenceInDays(payrollPeriodA.start, currentDate))) {
                    return 1
                }

                return -1
            },
        )

        yield put({
            type: ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS,
            currentPayrollPeriod: matchingPayrollPeriod || sortedPayrollPeriods[0],
        })
    } catch (error) {
        console.error(error)
        yield put({ type: ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE })
    }
}

export function* getEmployeeLoketBalances(action: GetEmployeeLoketBalances) : any {
    yield put({ type: ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST })

    try {
        const { loketEmployeeId } = action
        const loketLeaveBalance = yield getLoketLeaveBalance(loketEmployeeId)

        yield put({ type: ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS, loketLeaveBalance })
    } catch (_error) {
        yield put({ type: ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_FAILURE })
    }
}

export default function* absencesTsWatcher() {
    yield takeLatest(ABSENCES_SAGA_GET_CURRENT_PAYROLL_PERIOD, getCurrentPayrollPeriod)
    yield takeLatest(ABSENCES_SAGA_GET_EMPLOYEE_LOKET_BALANCES, getEmployeeLoketBalances)
}
